import * as React from 'react';
import {connect} from 'react-redux';
import toastr from 'toastr';
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
import {AttributeTypeEnum} from "../../enums/AttributeTypeEnum";
import Utils from "../../../../Utils";
import {deleteTenant,getAllTenants} from "../../../../actions/boCoreActions";
import {actions} from  '../../../../reducers/tenant'
import CreateTenantModal from "../../modals/CreateTenantModal/CreateTenantModal";
import "./TenantManagementGrid.css";

const AgGridReact = require('ag-grid-react').AgGridReact;
const $softHardDel = 
     Utils.$('<div id="qtipContainer"></div>')
    .append($("<label style='padding-top:5px'> Delete permanently?</label>"))
    .append($("<input id='multiValueToggle' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<label style='padding-top:5px'>Remove from storage?</label>"))
    .append($("<input disabled='true' id='removeFromStorage' type='checkbox' data-onstyle='primary' data-offstyle='danger' data-toggle='toggle' data-width='100%' data-height='20'/>"))
    .append($("<input id='submit-softhard-delete' type='button' style='float: right; color: black;margin-top:.5rem' value='Submit'/>"));


interface State {
    columnDefs: any;
    gridApi: any;
    columnApi: any;
    loading: boolean;
    rowData: any;
    isTenantModalOpen: boolean;
    allTenantOptions: any[];
    $softHardDel: any;
}

interface Props {
    updateTenants():void
}

class TenantManagementGrid extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            columnDefs: [],
            gridApi: null,
            columnApi: null,
            loading: false,
            rowData: [],
            isTenantModalOpen: false,
            allTenantOptions: [],
            $softHardDel: $softHardDel.clone(),
        }
    }

    componentDidMount() {
        this.getTenants();
        document.addEventListener('keydown', this.tenantsKeydownHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.tenantsKeydownHandler);
    }

    restoreEventListener = () => {
        document.addEventListener('keydown', this.tenantsKeydownHandler);
    }

    getTenants = () => {
        getAllTenants()
            .then((response) => {
                const gridData = response.data.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        timeZone: item.timeZone,
                        temporary: item.temporary,
                        updatedByProcess: item.updatedByProcess,
                        updatedByUser: item.updatedByUser,
                        tsCreated: Utils.moment(item.tsCreated, Utils.moment.ISO_8601).isValid() ? Utils.utcToLocalDate(item.tsCreated) : item.tsCreated,
                        tsUpdated: Utils.moment(item.tsUpdated, Utils.moment.ISO_8601).isValid() ? Utils.utcToLocalDate(item.tsUpdated) : item.tsUpdated
                    }
                });

                const tenantsDropDown = response.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                })
                this.setState({
                    rowData: gridData,
                    allTenantOptions: tenantsDropDown
                }, this.buildGrid)
            })
    }

    tenantsKeydownHandler = (e) => {
        if(e.ctrlKey && e.altKey && e.keyCode === 68) {
          Utils.$('#tenant_delete_btn').click();
         }
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 67) {
            Utils.$('#create-new-tenant').click();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.ag-floating-filter-input')[index].focus();
                }
            }
        }
    };

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.columnApi.getAllDisplayedColumns()[0];
            this.state.gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.gridApi.setFocusedCell(0, currentCol);
        }
    };

    buildGrid = () => {
        let columnDefs = [
            {
                id: "",
                headerName: "ID",
                field: "id",
                headerTooltip: "ID",
                type: 'text',
                checkboxSelection: true,
                dataType: AttributeTypeEnum.INT,
            },
            {
                field: 'name',
                headerName: "Name",
                tooltipField: 'Name',
                headerTooltip: "Name",
                type: 'text',
            },
            {
                field: 'temporary',
                headerName: "Temporary",
                tooltipField: 'Temporary',
                headerTooltip: "Temporary",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'updatedByProcess',
                headerName: "Updated By Process",
                tooltipField: 'Updated By Process',
                headerTooltip: "Updated By Process",
                type: 'text',
            },
            {
                field: 'updatedByUser',
                headerName: "Updated By User",
                tooltipField: 'Updated By User',
                headerTooltip: "Updated By User",
                type: 'text',
            },
            {
                headerName: "Created", field: "tsCreated",
                dataType: AttributeTypeEnum.TIMESTAMP,
                headerTooltip: "Created"
            },
            {
                headerName: "Updated", field: "tsUpdated",
                dataType: AttributeTypeEnum.TIMESTAMP,
                headerTooltip: "Updated"
            }
        ];

        this.setState({
            columnDefs: columnDefs
        }, () => this.addFilterIndex())
    }

    addFilterIndex = () => {
        Utils.$(".ag-floating-filter-input").each(function (index) {
            Utils.$(this).attr('id', 'userManagement-search-filter-' + index);
            Utils.$(this).attr('index', (index + 2));
        });
    };

    onGridReady = (params) => {
        if (!this.state.gridApi && !this.state.columnApi) {
            this.setState({
                gridApi: params.api,
                columnApi: params.columnApi
            }, () => {
                params.api.sizeColumnsToFit();
                Utils.$("#hide-nav-btn").on("click", function () {
                    setTimeout(() => {
                        params.api.sizeColumnsToFit();
                    }, 500);
                });
            })
        }
    }

    onGridReadyFirstRender = (params) => {
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        }, () => {
            params.api.sizeColumnsToFit();
            Utils.$("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    openCreateTenantModal = () => {
        document.removeEventListener('keydown', this.tenantsKeydownHandler);
        this.setState({
            isTenantModalOpen: true
        });
    }

    closeCreateTenantModal = () => {
        this.setState({
            isTenantModalOpen: false
        },this.restoreEventListener);
    };


    onCreateNewTenant = () => {
        this.getTenants();
    };

    refreshGrid = ():void => {
         this.state.gridApi.refreshCells({ force: true });
    };
  
    onDeleteHandler = (e) => {
      const selectedRows = this.state.gridApi.getSelectedRows();
      const instancesIds = this.state.gridApi.getSelectedRows() .map((item: any) => item.id);
     if (instancesIds.length > 0) {
          const $softHardDel = this.state.$softHardDel.clone();
           Utils.$(e.target).qtip({
           content: { 
               title: function () { return 'Delete Tenant'; },
               text: $softHardDel,
               button: 'Close', 
            },
           show: true,
           hide: 'unfocus',
          events: { show: () => { $(e.target).css('background-color', '#676A6C');
            },
           hide: () => {
               Utils.$(e.target).css('background-color','#1AB394');
               Utils.$('.qtip-dark').remove();
               Utils.$(e.target).qtip('destroy');
             },
           visible: () => {},
           render: () => {
                     let isHardDelete = false;
                     let removeFromStorage = false
                     let $multiValueToggle = $softHardDel
                     .children("#multiValueToggle").bootstrapToggle({
                          height: 30,
                          on: 'YES',
                          off: 'NO',
                          });
                    let $removeFromStorageToggle =  $softHardDel.children("#removeFromStorage").bootstrapToggle({
                            height: 30,
                            on: 'YES',
                            off: 'NO'
                        });
                   
                     $multiValueToggle.focus().select();
                      $multiValueToggle.change(function () {
                      if ($multiValueToggle[0].checked) {
                          isHardDelete = true;
                          $removeFromStorageToggle.bootstrapToggle('enable');
                        } else { 
                            isHardDelete = false
                            removeFromStorage = false
                            Utils.$("#removeFromStorage").parent().removeClass('btn-primary').addClass('btn-danger off')
                            $removeFromStorageToggle[0].checked = false
                            $removeFromStorageToggle.bootstrapToggle('disable');
                         }
                      });

                      $removeFromStorageToggle.focus().select();
                      $removeFromStorageToggle.change(function () {
                          if ($removeFromStorageToggle[0].checked) {
                              removeFromStorage = true
                          } else {
                             removeFromStorage = false
                          }
                      });
                       const submitSoftHardDele = () => {
                       Utils.$('.qtip').remove();
                       deleteTenant({
                        hardDelete: isHardDelete,
                        removeFromStorage,
                        tenantId: instancesIds[0],
                         }).then(() => {
                             this.props.updateTenants()
                             this.state.gridApi.updateRowData({ remove: selectedRows });
                             this.refreshGrid();
                           });
                        };
                         Utils.$('#submit-softhard-delete').unbind().on('click', () => {
                              submitSoftHardDele();    
                         });
                        Utils.$('#qtipContainerImport').unbind().on('keydown', (evt) => {
                             if (evt.keyCode === 27) {
                                Utils.$('.qtip').remove();
                             }
                        });
                      },
                   },
                    position: {
                     my: 'top right',
                     at: 'bottom center',
                     viewport: $(document.body),   
                    },
                   style: {
                     classes: 'qtip-dark',
                     width: 350,
                },

            });

        } else {    
            toastr.warning('Please select at least one record.');
          }
  };

    render() {
        return (
            <div style={{height: 'calc(100% - 70px)'}}>
                <header style={{height: 50, display: "flex"}} className="bo-core-header top-header">
                    <div style={{
                        float: "left",
                        paddingLeft: 4,
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <span className="header-title">Tenant Management</span>
                        <div className='tenant-action-buttons-wrapper'>
                        <div className="control-buttons">
                            <button onClick={this.openCreateTenantModal} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'create-new-tenant'} title={'CTRL + ALT + C'}>
                                  <i className="fas fa-plus"/> 
                                  <strong style={{fontSize: '13px'}}className={'shortcut-btn-letters u-btn-mr-l'}>C</strong>reate
                                Tenant
                            </button>
                        </div>
                        <button 
                          style={{marginRight: '2px'}}
                          id="tenant_delete_btn"
                          className="btn btn-danger tenant-delete"
                          title={'CTRL + ALT + D'}
                          onClick={this.onDeleteHandler}>
                         <i className="fas fa-trash-alt"/> 
                         <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters u-btn-mr-l'}>D</strong>elete
                          </button>
                        </div>
                    </div>
                </header>
                <div style={{height: '102%', padding: '10px 10px 0 10px'}}>
                    <div style={{width: "100%", height: "99%"}} className={"ag-theme-balham-dark ag-grids"}>
                        <AgGridReact
                            onGridReady={this.onGridReady}
                            onFirstDataRendered={this.onGridReadyFirstRender}
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.rowData}
                            defaultColDef={{
                                minWidth: 150,
                                flex: 1,
                                filter: "agTextColumnFilter",
                                floatingFilter: true,
                                sortable: true,
                                autoHeight: true,
                                resizable: true,
                            }}
                            gridOptions={{
                                suppressDragLeaveHidesColumns: true,
                                floatingFilter: true,
                                suppressRowClickSelection: true,
                                blockLoadDebounceMillis: 300,
                            }}
                            animateRows={true}
                           />
                    </div>
                </div>
                <CreateTenantModal
                    isOpen={this.state.isTenantModalOpen}
                    onCloseModal={this.closeCreateTenantModal}
                    onCreate={this.onCreateNewTenant}
                    tenantOptions={this.state.allTenantOptions}
                />
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        updateTenants:() => {dispatch({type:actions.UPDATE_TENANTS,payload:true})}
    }
};

export default connect(null, mapDispatchToProps)(TenantManagementGrid)


// WEBPACK FOOTER //
// ./app/components/bo-core/grids/TenantManegementGrid/TanantManagementGrid.tsx